// Note: more types exposed from `index.d.ts`.
export { mdxJsx } from './lib/syntax.js';